<template>
  <div class="">
    <!-- heading -->
    <h1 class="text-muted mb-4">
        <i class="fa fa-home" aria-hidden="true"></i>
        Home
    </h1>	
    <div>            
        <div>			 
			<ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" 
						id="pills-home-tab" 
						data-toggle="pill" 
						href="#pills-home" 
						role="tab" 
						aria-controls="pills-home" 
						aria-selected="true">
												
						Your dashboard
					</a>
				</li>
				<li class="d-none nav-item">
					<a class="nav-link" 
						id="pills-profile-tab" 
						data-toggle="pill" 
						href="#pills-profile" 
						role="tab" 
						aria-controls="pills-profile" 
						aria-selected="false">
						incomplete
					</a>
				</li>
				<li class="d-none nav-item">
					<a class="nav-link" id="pills-contact-tab" data-toggle="pill" href="#pills-contact" role="tab" aria-controls="pills-contact" aria-selected="false">Contact</a>
				</li>								
			</ul>						
			<div  id="pills-tabContent">				
				<div class="col-sm-12">
					<!-- remove this once i do proper form validation -->
					<form  id="initialForm"></form>  						
					<section class="col-sm-12  d-lg-flex  justify-content-between">		
						<!-- ORDERS -->
						<div class="p-2 ml-2 mt-5 mb-5 col-lg-3 col-sm-12 border border-light rounded shadow">
							<div class="d-flex justify-content-between">
									<h5><vue-fontawesome class="mr-2" icon="cart-arrow-down"></vue-fontawesome>	Orders today</h5>
									<small><router-link to="/order">view orders</router-link></small>
								</div>
								<h1 class="ml-4 text-success font-weight-bold">{{new_orders}}</h1>
								<hr>
								<div class="mt-3">
									<div class="d-flex justify-content-between">
										<h6 class="text-danger">pending</h6> 
										<h6 class="text-danger">{{pending | intcomma}}</h6>
									</div>
									<div class="d-flex justify-content-between">
										<h6 class="text-muted">complete</h6>
										<h6>{{complete}}</h6>
									</div>																											
								</div>
								<hr>
								<div class="col-lg-12">									
									<small class="text-muted">total items in orders</small>											
									<h2>{{value}}</h2>
							</div>								
						</div>	
						<!-- SALES-->
						<div class="p-4 ml-2  col-lg-6 col-sm-12 border border-light rounded shadow" style="height: 70vh">
							<div class="d-flex justify-content-between">
								<h5><vue-fontawesome class="mr-2" icon="shopping-bag"></vue-fontawesome>Sales today</h5>
								<small><router-link to="/sales">view sales</router-link></small>
							</div>								
							<h1 class="ml-4 text-success font-weight-bold">{{sales_count}}</h1>
							<hr>
							<div class="mt-3">
								<div class="d-flex justify-content-between">
									<h6 class="text-muted">Total products</h6> 
									<h6>{{total_items | intcomma}}</h6>
								</div>
								<div class="d-flex justify-content-between">
									<h6 class="text-muted">Total value of sales</h6>
									<h6 v-if="$hasPermission('VIEW_SALES')">{{total_cost | intcomma}}</h6>
									<i v-else class="fa fa-shield" aria-hidden="true"></i>
								</div>
								<div class="d-flex justify-content-between">
									<h6 class="text-muted">Total payments made</h6>
									<h6 v-if="$hasPermission('VIEW_SALES')" >{{total_payment | intcomma}}</h6>
									<i v-else class="fa fa-shield" aria-hidden="true"></i>
								</div>									
								<div class="d-flex justify-content-between">
									<h6 class="font-weight-bold">Gross profit</h6>
									<h6 class="font-weight-bold" v-if="profits && $hasPermission('GROSS_PROFIT_PER_SALE')">{{profits.total | intcomma}}</h6>
									<h6 v-if="! profits && $hasPermission('GROSS_PROFIT_PER_SALE')">...</h6>
									<h6 v-if="! $hasPermission('GROSS_PROFIT_PER_SALE')"><i class="fa fa-shield" aria-hidden="true"></i></h6>
								</div>
							</div>
							<hr>
							<div class="col-lg-12">									
								<lineGraph v-if="render_graph" style="height: 150px" :data="sales_graph_data" :options="options"/>
							</div>
						</div>
						<!-- STOCK -->
						<div class="p-2 ml-2 mt-5 mb-5 col-lg-3 col-sm-12 border border-light rounded shadow">
							<div class="d-flex justify-content-between">
									<h5><vue-fontawesome class="mr-2" icon="sort"></vue-fontawesome>In stock today</h5>
									<small><router-link to="/stock">view stock</router-link></small>
								</div>
								<div class="d-flex">
									<h1 class="ml-4 text-success font-weight-bold">
										{{in_stock | intcomma}}
									</h1>
									<small v-if="stocks" class="mt-4 small text-muted"> / {{stocks.length| intcomma}}</small>
								</div>
								<hr>
								<div class="mt-3">
									<div class="d-flex justify-content-between">
										<h6 class="text-danger">Out of Stock</h6> 
										<h6 class="text-danger">{{out_of_stock | intcomma}}</h6>
									</div>
									<div class="d-flex justify-content-between">
										<h6 class="text-muted">Below re-order level</h6>
										<h6>{{below_level}}</h6>
									</div>																											
								</div>
								<hr>
								<div class="col-lg-12">									
									<small class="text-muted">last stock count</small>
									<h2 v-if="last_count != 'Data not found'">{{last_count | dateformat}}</h2>
									<h2 v-else>{{last_count}}</h2>
							</div>								
						</div>
					</section>
				</div>				
				<div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
					<table class="table table-borderless">
						<thead>
							<tr>
							<th scope="col">#</th>
							<th scope="col">First</th>
							<th scope="col">Last</th>
							<th scope="col">Handle</th>
							</tr>
						</thead>
						<tbody>
							<tr>
							<th scope="row">1</th>
							<td>Mark</td>
							<td>Otto</td>
							<td>@mdo</td>
							</tr>
							<tr>
							<th scope="row">2</th>
							<td>Jacob</td>
							<td>Thornton</td>
							<td>@fat</td>
							</tr>
							<tr>
							<th scope="row">3</th>
							<td>Larry</td>
							<td>the Bird</td>
							<td>@twitter</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">...</div>
			</div> 		  
		</div>		        		  
    </div>        
  </div>
</template>

<script>
// @ is an alias to /src
import lineGraph from '@/components/charts/line.vue'
export default {
	name: 'Home',
	components: {lineGraph},
data(){
	return{				
		sales:null,		
		profits: null,
		from_date: null,
		to_date: null,
		//receipt modal.
		receipt_modal_data:null,
		//sales graph
		render_graph: false,
		options:{
			legend: {
				display: false,
			},
			scales: {
				xAxes: [{
					display: false
				}],
				yAxes: [{
					display: false
				}],
			},
			responsive: true,
			maintainAspectRatio: false
		},
		sales_graph_data:{
			labels: [],
			datasets: [{
				label: "sale value",				
				data: []
			}]
		},
		//STOCK
		stocks: null,
		in_stock: "...",
		out_of_stock: "...",
		below_level: "...",
		//orders
		orders: null,		
		new_orders: "...",
		pending: "...",
		complete: "...",
		value: "..."
	}
},
mounted(){
	document.getElementById('initialForm').submit((e)=>{
		e.preventDefault()
	})
	this.from_date = this.$moment().subtract(0, 'days').format('YYYY-MM-DD')
	this.to_date = this.$moment().format('YYYY-MM-DD')

	this.getSales()
	this.getProfits()
	this.getStock()
	this.getOrders()
},
computed:{
	account_switched(){
		return this.$store.state.account_switch_count
	}, 
	last_count(){
		var last_count = localStorage.getItem('last_stock_count')
		if (last_count){
			return last_count
		}
		else{
			return "Data not found"
		}
	},
	sales_count(){
		if (this.sales){
			return this.sales.length
		}
		else{
			return "..."
		}
	},
	total_items(){
		if (this.sales){			
			return this.totalItems()
		}else{
			return "..."
		}
	},
	total_cost(){
		if (this.sales){			
			return this.totalCost()
		}else{
			return "..."
		}
	},
	total_payment(){
		if (this.sales){			
			return this.totalPayment()
		}else{
			return "..."
		}
	}
},
watch:{
	account_switched: function(){
		this.getSales()
		this.getProfits()
		this.getStock()
		this.getOrders()
	},
	new_sale: function (){
		this.getSales()
		this.getProfits()
		this.getStock()
	},
	sales : function(){
		if (this.sales){
			this.render_graph = false 
			for (var sale of this.sales){								
				var date =  this.$moment(sale.date).format('h:mm a')
				this.sales_graph_data.labels.push(date)
                this.sales_graph_data.datasets[0].data.push(this.totalCostForEachSale(sale.products))
			}
			setTimeout(()=>{
				this.render_graph = true
			},1000)			
		}
	},
	stocks: function(){
		if (this.stocks){			
			this.in_stock = 0, this.out_of_stock = 0, this.below_level = 0
			for (var stock of this.stocks){
				if (stock.total > 0){
					this.in_stock += 1
				}
				if (stock.total <= 0){
					this.out_of_stock += 1
				}
				if (stock.total < stock.minimumRequired && stock.minimumRequired != 0){
					this.below_level += 1
				}
			}
		}
	},
	orders: function(){
		if (this.orders){
			this.pending = 0, this.new_orders = 0, this.complete = 0, this.value = 0
			for (var order of this.orders){
				if (order.state === "new_orders"){
					this.new_orders += 1
				}
				if (order.state === "pending"){
					this.pending += 1
				}
				if (order.state === "complete"){
					this.complete += 1
				}
				this.value += order.items.length
			}
		}
	}
},
methods:{
		//get sales by user
		getSales:function(){
			//convert date to unix timestamp
			this.sales = null
			this.$http({
                method:'get',
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/list-sales`,
				params:{
					date0: this.from_date,
					date1: this.to_date
				},
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{
                this.sales = response.data
            }).catch((err)=>{
                this.$emit('alert',err)
            })
		},		
		totalItems: function(){
			var total = 0
			for (var sale of this.sales){
				for (var i in sale.products){
					total += parseInt(sale.products[i].qty)
				}
			}
			return total
		},
		totalCost: function(){
			var total = 0.00
			for (var sale of this.sales){
				for (var i in sale.products){				
					total += parseFloat(sale.products[i].total)
				}
			}		
			return total
		},
		totalPayment: function(){
			var total = 0.00
			for (var sale of this.sales){
				for (var i in sale.payments){
					total += parseFloat(sale.payments[i].amount)
				}
			}			
			return total
		},
		totalCostForEachSale: function(products){
			var total = 0.00
			for (var i in products){				
				total += parseFloat(products[i].total)
			}
			return total
		},
		//get profits
		getProfits: function(){     
			this.getting_reports = true       
			this.$http({
				method:'get',				
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/gross_profit_per_sale/${this.from_date}/${this.to_date}`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				}
			}).then((response)=>{			
				this.profits = response.data 
			}).catch((err)=>{				
				this.$emit('alert',err)
			})
		},
		//get stocks.
		getStock:function(){                          
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/stock`,               
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{
                this.stocks = response.data
            }).catch((err)=>{
				this.$emit('alert',err)
            })
		}, 
		//get orders.
		getOrders: function(){  
			this.orders = null
			this.$http({
				method:'get',
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/sale-orders/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},
				params:{
					date0: this.from_date,
					date1: this.to_date
				},
			}).then((response)=>{
				this.orders = response.data
			}).catch((err)=>{
				this.$emit('alert',err)
			})
		},
    }
}
</script>